import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LearnpageService {

  constructor(private http: HttpClient) { }
  getData = () => {
    return this.http.get(environment.userApiUrl + 'api/admin/learnPage')
  }
  add = (data: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/learnPage', data)
  }
  update = (data: any) => {
    return this.http.put(environment.userApiUrl + 'api/admin/learnPage', data)
  }
  delete = (id: any) => {
    return this.http.delete(environment.userApiUrl + 'api/admin/LearnPageById/' + id)
  }
}